export const criarControleVolume = (agora: () => number = Date.now) => {
  const assinaturas = new Map<string, number>()
  const objetos = new WeakMap<object, number>()
  let inicioJanela = agora()
  let relatos = 0
  let descartes = 0
  let qualidade = 0

  const incrementar = (valor: number): number => Math.min(valor + 1, Number.MAX_SAFE_INTEGER)
  const descartar = (): false => { descartes = incrementar(descartes); return false }

  return {
    permitir(assinatura: string, erro: unknown): boolean {
      const instante = agora()
      if (instante - inicioJanela >= 60000 || instante < inicioJanela) {
        inicioJanela = instante
        relatos = 0
      }
      for (const [chave, momento] of assinaturas) {
        if (instante - momento >= 60000 || instante < momento) assinaturas.delete(chave)
      }
      const objeto = erro !== null && (typeof erro === 'object' || typeof erro === 'function') ? erro : undefined
      const ultimo = objeto ? objetos.get(objeto) : undefined
      if ((ultimo !== undefined && instante - ultimo >= 0 && instante - ultimo < 60000)
        || assinaturas.has(assinatura) || relatos >= 20) return descartar()
      if (assinaturas.size >= 200) return descartar()
      assinaturas.set(assinatura, instante)
      if (objeto) objetos.set(objeto, instante)
      relatos++
      return true
    },
    registrarDescarte(): void { descartar() },
    registrarQualidade(): void { qualidade = incrementar(qualidade) },
    obterContagens: () => ({ descartes, qualidade, assinaturas: assinaturas.size }),
  }
}
